module.exports = __webpack_public_path__ + "img/mobile_about_img.a77681bd.jpg";